import { render, staticRenderFns } from "./ProfileColor.vue?vue&type=template&id=1b175a54"
import script from "./ProfileColor.vue?vue&type=script&lang=js"
export * from "./ProfileColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports